import lodash from "lodash";

export type UniqByIteratee<T> = (item: T) => unknown;

export type PropertyPath = string;

export type UniqBySelector<T> = UniqByIteratee<T> | PropertyPath;

export const uniqBy = <T>(array: T[], selector: UniqBySelector<T>): T[] => {
    if (!Array.isArray(array)) {
        throw new Error("Expected first argument to be an array");
    }

    if (array.length === 0) {
        return [];
    }

    return lodash.uniqBy(array, selector);
};

export function uniqById<T extends { id: string | number }>(array: T[]): T[] {
    return uniqBy(array, "id");
}
